<template>
  <div>
    <zj-layout-container
      v-loading="loading"
      :element-loading-text="loadingText"
    >
      <zj-layout-header>
        <div class="listtitle">应急典型案例</div>
        <el-form
          class="zj-search-form"
          ref="form"
          :model="form"
          :label-width="labelWidth"
        >
          <el-form-item label="案例名称">
            <el-input
              v-model="DocumentName"
              placeholder="请输入案例名称"
            ></el-input>
          </el-form-item>
          <el-form-item label class="right">
            <el-button @click="onSearch">查 询</el-button>
            <el-button @click="onCancel">清 理</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>

      <zj-layout-main>
        <div class="zj-button-bar">
          <el-button size="mini" @click="onAdd">添 加</el-button>
        </div>
        <div class="zj-layout-main-content bgcolor scrollable">
          <div class="zj-table-container">
            <el-table
              :data="tableData"
              ref="multipleTable"
              border
              style="width: 100%"
              fixed
            >
              <el-table-column
                type="index"
                label="序号"
                width="80"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="DocumentName"
                label="典型案例名称"
              ></el-table-column>
              <el-table-column
                prop="HappenTime"
                label="发生时间"
                :formatter="formatDate"
              ></el-table-column>
              <el-table-column
                prop="HappenAddress"
                label="发生地点"
              ></el-table-column>
              <el-table-column label="操作" width="120" align="center">
                <template slot-scope="scope">
                  <template>
                    <el-button
                      @click="queryDetail(scope.$index,scope.row)"
                      type="text"
                      size="small"
                      >查看</el-button
                    >

                    <el-button
                      @click="editDetail(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      >编辑</el-button
                    >
                    <el-button
                      @click="deleteClick(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      >删除</el-button
                    >
                  </template>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </zj-layout-main>
      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
      <div></div>
    </zj-layout-container>
  </div>
</template>

<script>
import MyApis from "../../../apis";

export default {
  name: "ClassicCaseView",
  controller: "UI",
  action: "ClassicCaseView",

  data() {
    return {
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableData: [],
      DocumentName: "",
      RiskEventId: "",
      RiskEventArr: [],
      loading: false,
      loadingText: "加载中...",
      pdfUrl: "",
      previewShow: false,
    };
  },
  created: function () {
  },
  mounted: function () {
    this.search();
    this.logInfo.ActionName = "应急处置方案查询";
    this.logInfo.LogMessage = "应急处置方案查询";
    this.logInfo.ModuleName = "风险应急";
    this.logInfo.PageName = "应急处置方案列表";
    this.addOperationLog();
  },
  methods: {
    search() {
      let searchInfo = {
        DocumentName: this.DocumentName,
        DocumentTypeId: 1,
        PageSize: this.pageSize,
        PageIndex: this.currentPage,
        TotalCount: 0,
        StartNumber: 0,
        EndNumber: 0,
      };
      this.loading = false;
      new MyApis.DocumentApi()
        .GetItemPagingList(searchInfo)
        .then((r) => {
          r = r.data.Data;
          this.tableData = r.PageContents;
          this.total = r.BaseSearch.TotalCount;
          this.loading = false;
        })
        .catch((e) => {
          this.loading = false;
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    //添加
    onAdd() {
      this.$router.push({
        path: "/plugin/emergency/UI/ClassicCaseInfo",
        query: {
          type: "add",
        },
      });
    },
    //查看
    queryDetail(index, row) {
      this.$router.push({
        path: "/plugin/emergency/ui/ClassicCaseInfo",
        query: { InfoId: row.Id, type: "query" },
      });
    },
    //编辑
    editDetail(index, row) {
      this.$router.push({
        path: "/plugin/emergency/ui/ClassicCaseInfo",
        query: { InfoId: row.Id, type: "edit" },
      });
    },
    //行删除
    deleteClick(index, row) {
      this.$confirm("此操作将永久删除该行数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.loading = true;
          this.loadingText = "删除中...";
          new MyApis.DocumentApi()
            .DelItem({ Id: row.Id })
            .then((r) => {
              r = r.data.Data;
              if (r) {
                this.$message({
                  type: "success",
                  message: "删除成功!",
                });
                this.logInfo.ActionName = "应急处置方案删除";
                this.logInfo.LogMessage = "应急处置方案删除";
                this.logInfo.ModuleName = "风险应急";
                this.logInfo.PageName = "应急处置方案列表";
                this.addOperationLog();
              } else {
                this.$message({
                  type: "error",
                  message: "删除失败!",
                });
              }
              this.loading = false;
              this.search();
            })
            .catch((e) => {
              this.loading = false;
              console.log(e);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 点击查询按钮
    onSearch() {
      this.currentPage = 1;
      this.search();
    },
    clearsearch() {
      this.DocumentName = "";
    },
    // 点击取消按钮
    onCancel() {
      this.clearsearch();
      this.search();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
    //日期列表展示格式
    formatDate(row, column) {
      // 获取单元格数据
      let data = row[column.property];
      if (data == null || data == "0001-01-01T00:00:00") {
        return null;
      }
      return new Date(data).format('yyyy-MM-dd');
    },
  },
};
</script>

<style lang="scss">
.customClass {
  .el-dialog__header {
    padding: 16px !important;
    margin: 0;
  }
  .el-dialog__header .el-dialog__headerbtn {
    top: 5rem !important;
    right: 4.8rem !important;
  }
}
</style>
